import type { ApolloClient } from '@apollo/client';
import {
  ProductCategoryFilter,
} from '_graphql/__generated__/globalTypes';
import { getCategories } from '_graphql/queries/products';
import type { GetProductCategories } from '_graphql/queries/__generated__/GetProductCategories';

const PAGE_SIZE = 250;

/**
 * Loads physical product categories for the signed-in supplier (optionally filtered by country).
 */
export async function fetchAllProductCategories(
  client: ApolloClient<object>,
  params: { supplierId: string; country?: string | null },
): Promise<{ id: string; name: string }[]> {
  const filter: ProductCategoryFilter = {
    type: { eq: 'PHYSICAL' },
    supplier_id: { eq: params.supplierId },
  };
  if (params.country) {
    filter.country = { eq: params.country };
  }

  const out: { id: string; name: string }[] = [];
  let offset = 0;

  for (;;) {
    const { data } = await client.query<GetProductCategories>({
      query: getCategories,
      variables: {
        filter,
        pagination: { limit: PAGE_SIZE, offset },
      },
      fetchPolicy: 'network-only',
    });

    const batch = (data?.getProductCategories ?? []).filter(
      (c): c is NonNullable<typeof c> => c != null,
    );
    for (const c of batch) {
      out.push({ id: c.id, name: c.name });
    }

    if (batch.length < PAGE_SIZE) {
      break;
    }
    offset += PAGE_SIZE;
  }

  return out;
}
